export const normalizeHtmlContent = (content: string): string => {
  if (!content) return '';

  return content
    .replace(/\\n/g, '<br/>') // \n karakterlerini <br/> etiketine çevir
    .replace(/\\/g, '') // Kalan escape karakterlerini temizle
    .replace(/\s+/g, ' ') // Fazla boşlukları tek boşluğa çevir
    .trim(); // Baştaki ve sondaki boşlukları temizle
};
